var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCivilization = function SvgCivilization(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M3 20.077v-1.5h3.462v-4.25H4.73v-1.5h1.792q.185-1.837 1.514-3.146a5.36 5.36 0 0 1 3.174-1.543V3.5h6.039v3.423h-4.539v1.215q1.847.233 3.175 1.543 1.329 1.309 1.514 3.146h1.792v1.5h-1.73v4.25h3.461v1.5zm4.962-1.5h3.25v-4.25h-3.25zm4.75 0h3.25v-4.25h-3.25zm-4.658-5.75h7.815a3.62 3.62 0 0 0-1.333-2.336 3.95 3.95 0 0 0-2.575-.914 3.95 3.95 0 0 0-2.574.914 3.62 3.62 0 0 0-1.333 2.336"
  })));
};
export default SvgCivilization;